var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "ico-profile",
    width: 24,
    height: 24,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACHElEQVRIia3VTYjNYRQG8N+9hhDSzITko7BEPhYoI1nIRxRlgSmRktUsELKx0yyUrGSLjdKkkY+FWEhXWDDKQj5CExn5WI3GGL11bv278//P3OE+dTtv933v87znnOc9t+TKHaNgHjqxBuPj6AAe4jg+jPTzplHIjwZJa87efGzEGZz9F4ETOIUp+IlPeIoSVmImWnA6eDrzSIpKtAiP0Iw+HMT1mjM7cDGy+4pVeF1LVC64/fkg/459OeQJXdiPH5HJuTyiIoGlEVMDbxacSbiBj7FeXq/A1Exv7o9AXsW9iOMwuR6BSXE44VcdAgMRS3mmyRNITf0d63V1CLRFHAy3jSrwB+9ivbCotoEVWBDrYQ4qEkg4Fg5qiUYuzjmzJPaqbjuSR1T00B6gG7swO5rdg1tR600hkC7Qj6t4PBaB1TV7iWh9fLJINb+GwwU8w0qUCF7iNnZjYmavPx5VX4yNJ9iGA2jHl8iyLUvYlImXIvXp8V0i+hYjI5XsVdQ6fddbY+ENMTJao7RdMV4GqwLdcWhCzJW7OIk3RanXoAPTwtapnHswC5uTwN5IK5G/x3Y8q5O4ilS6nVgWcyv9h6xNQmma9oQNP4eve8dIXos5MdZn4EU5fCxu/b/kYvg9j3VzOeOktw0gr6L6qstFL7lhSE0eCrItuNAg4q0Rh5JAJZwzF4caePk0XStJIL3CyzEe0pxpBFJVKmj/Cy3wbbGkx7yuAAAAAElFTkSuQmCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProfile);
export default __webpack_public_path__ + "static/media/ico-profile.5b037488.svg";
export { ForwardRef as ReactComponent };